<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "CallCenter"
};
</script>

<style></style>
